import { Injectable } from '@angular/core';
import { AbstractDialogService, DialogOptions } from '@examdojo/core/dialog';
import { MobileMenuSheetDialogComponent } from './mobile-menu-sheet-dialog.component';
import { MOBILE_MENU_SHEET_DIALOG_ID, MobileMenuSheetDialogData } from './mobile-menu-sheet-dialog.model';

@Injectable({ providedIn: 'root' })
export class MobileMenuSheetDialogService extends AbstractDialogService<
  MobileMenuSheetDialogData,
  void,
  typeof MobileMenuSheetDialogComponent
> {
  readonly id = MOBILE_MENU_SHEET_DIALOG_ID;
  protected readonly component = MobileMenuSheetDialogComponent;

  override readonly options: DialogOptions = {
    cssClass: 'auto-height mobile-menu-sheet-dialog',
    breakpoints: [0, 1],
    initialBreakpoint: 1,
    handle: true,
  };

  open(data: MobileMenuSheetDialogData, beforeDismissCallback?: () => unknown | Promise<unknown>) {
    return this.openDialog({
      input: data,
      beforeDismissCallback,
      options: {
        componentProps: {
          items: data.items,
          settingsRoute: data.settingsRoute,
        },
      },
    });
  }
}
